import { styled } from '@clickcease/cc-client-components-lib'

export const PricingPlanBoxPriceRow = styled('div', {
  display: 'flex',
  position: 'relative',
})

export const PricingPlanBoxOriginalPrice = styled('div', {
  color: '$primaryColor',
  fontSize: '$h3',
  fontWeight: '$sb',

  '&:before': {
    position: 'absolute',
    content: '',
    left: '123px',
    top: '23%',
    width: '48px',
    right: '0',
    borderTop: '$primaryColor 1px solid',

    '-webkit-transform': 'rotate(332deg)',
    '-moz-transform': 'rotate(332deg)',

    '-ms-transform': 'rotate(332deg)',
    '-o-transform': 'rotate(332deg)',
    transform: 'rotate(332deg)',
  },
})

export const CrossSellPlanBoxSeparator = styled('div', {
  width: '100%',
  height: '1px',
  background: '$lightGray',
  margin: '$2 0px $2 0px',

  '@laptop': {
    marginBottom: '$4',
  },
})

export const CrossSellPlanBoxDiscount = styled('div', {
  margin: '$6 0px $8 0px',
})

export const PaymentPlanTitle = styled('div', {
  fontSize: '$md',
})
export const InstallmentsSubscriptionWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: '$2',
})
